var map = {
	"./gao2025treat.png": 4379,
	"./huang2023emotionally.png": 6566,
	"./huang2024far.png": 3537,
	"./huang2024humanity.png": 7046,
	"./huang2024reliability.png": 1064,
	"./lam2025codecrash.png": 3280,
	"./li2025jsprotect.png": 1852,
	"./xiao2025designbench.png": 5097,
	"./zhou2025pimmur.png": 9994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9183;